/**
 * @generated SignedSource<<abdc2bfed5aff26cd65905a793ad2a6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionList_Routine$data = {
  readonly id: string;
  readonly isArchived: boolean;
  readonly isOrg: boolean;
  readonly occasion: {
    readonly occasionSections: ReadonlyArray<{
      readonly id: string;
      readonly sectionVersion: {
        readonly title: string | null;
      };
      readonly taskExecutions: ReadonlyArray<{
        readonly id: string;
        readonly task: {
          readonly id: string;
        };
        readonly todos: ReadonlyArray<{
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionTodoIssue_todo">;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionScreenListItemComponent_TaskExecution">;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionSectionHeader_routineOccasionSection">;
    }>;
    readonly store: {
      readonly myRole: Roles;
      readonly " $fragmentSpreads": FragmentRefs<"useHasFeatureInTier_Store" | "usePermissions_store">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"OccasionSelector_routineOccasion" | "RoutineOccasionAssignees_RoutineOccasion">;
  };
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionScreenRoutineDescription_Routine">;
  readonly " $fragmentType": "RoutineOccasionList_Routine";
} | null;
export type RoutineOccasionList_Routine$key = {
  readonly " $data"?: RoutineOccasionList_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionList_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "sequenceNumber"
    },
    {
      "kind": "RootArgument",
      "name": "storeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionList_Routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionScreenRoutineDescription_Routine"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "sequenceNumber",
            "variableName": "sequenceNumber"
          },
          {
            "kind": "Variable",
            "name": "storeId",
            "variableName": "storeId"
          }
        ],
        "concreteType": "RoutineOccasion",
        "kind": "LinkedField",
        "name": "occasion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "myRole",
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "usePermissions_store"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useHasFeatureInTier_Store"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoutineOccasionAssignees_RoutineOccasion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OccasionSelector_routineOccasion"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": "RoutineOccasionSection",
              "kind": "LinkedField",
              "name": "occasionSections",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RoutineOccasionSectionHeader_routineOccasionSection"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineSectionVersion",
                  "kind": "LinkedField",
                  "name": "sectionVersion",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "taskExecutions",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "task",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Todo",
                      "kind": "LinkedField",
                      "name": "todos",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "RoutineOccasionTodoIssue_todo"
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "RoutineOccasionScreenListItemComponent_TaskExecution"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            "action": "NONE"
          }
        ],
        "storageKey": null
      },
      "action": "NONE"
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "7b12255d5dca26a167cedd270c0acfa9";

export default node;
